


























































import {TranslateResult} from 'vue-i18n'
import {Component, Vue } from 'vue-property-decorator'

import {namespace} from 'vuex-class'
import CommonWidgetInfobar from '@/components/common/widget/Testing.vue';
import IWorkspace from '@/components/icons/IWorkspace.vue';
import ISettings from '@/components/icons/ISettings.vue';
import IShardList from '@/components/icons/IShardList.vue';
import IStatistic from '@/components/icons/IStatistic.vue';
import ISupport from '@/components/icons/ISupport.vue';
import IMailing from '@/components/icons/IMailing.vue';
import NameExhibition from '@/components/UI/NameExhibition.vue';



const auth = namespace('auth')
const profile = namespace('profile')
const app = namespace('app')
const locale = namespace('locale')
const event = namespace('event')
const roistat = namespace('roistat')
const workspace = namespace('workspace')
const dialog = namespace('dialog')
const forms = namespace('forms')

interface ISidebarMenu {
  route: string
  icon: IIcon
  text: TranslateResult
  displayConditionPlan: (v: any) => {}
}

interface IIcon {
  color?: string
  component: string | object
  width?: string
  height?: string
}

@Component({
  components: {
    IWorkspace,
    ISettings,
    IShardList,
    IStatistic,
    ISupport,
    IMailing,
    CommonWidgetInfobar,
    NameExhibition,
  }
})
export default class SidebarFull extends Vue {
  @event.Getter('shows') protected shows:any
  @auth.Action('logout') protected authLogout: any
  @roistat.Action('sendEvent') protected sendEvent:any
  @profile.State("userCompany") protected userCompany: any
  @profile.Getter('getCurrentCompany') protected getCurrentCompany:any
  @profile.Getter('getCurrentWorkspace') protected getCurrentWorkspace:any
  @workspace.Getter('getPlan') protected getPlan: any
  @workspace.Getter('getPlanStatus') protected getPlanStatus: any
  @dialog.Getter('topAlertShow') protected topAlertShow: any
  @dialog.Mutation('SetTitleDialog') protected SetTitleDialog: any
  @dialog.Mutation('SetSubtitleDialog') protected SetSubtitleDialog: any
  @dialog.Mutation('SetFormSDialog') protected SetFormSDialog: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @forms.Mutation('setOptions') protected setOptions: any

  protected workspace: string = ''

  menu: ISidebarMenu[] = [
    {
      route: this.workspace == 'personal' ? 'Personal' : 'Corporate',
      icon: {
        component: 'IWorkspace'
      },
      text: 'sidebar.workspace',
      displayConditionPlan: (v: any) => {
        return true
      }
    },
    {
      route: 'Settings',
      icon: {
        component: 'ISettings',
      },
      text: 'sidebar.settings',
      displayConditionPlan: (v: any) => {
        return v && (v.role == 'owner' || v.role =='marketer' || v.role =='support')
      }
    },
    {
      route: 'Shards',
      icon: {
        component: 'IShardList',
      },
      text: 'sidebar.collectedData',
      displayConditionPlan: (v: any) => {
        return true
      }
    },
    {
      route: 'Statistics',
      icon: {
        component: 'IStatistic',
      },
      text: 'sidebar.statistic',
      displayConditionPlan: (v: any) => {
        return v && (v.role == 'owner' || v.role =='marketer' || v.role =='support')
      }
    },
    {
      route: 'MailingList',
      icon: {
        component: 'IMailing',
      },
      text: 'mailing.config.leadfrog.mailing',
      displayConditionPlan: (v: any) => {
        return v && (v.role == 'owner' || v.role =='marketer' || v.role =='support')
      }
    },
    // {
    //   route: 'Support', 
    //   icon: {
    //     component: 'ISupport'
    //   },
    //   text: 'sidebar.support',
    //   displayConditionPlan: (role: string) => {
    //     return role !== 'admin'
    //   }
    // },

  ]

  protected tryLogout() {
    this.authLogout()
      .then(() => {
        this.$router.push({name: 'Auth'}).catch(() => {})
      })
      .catch(() => {
      })
  }

  protected image: string = '/img/sidebar.jpg'
  protected sidebarOverlayGradiant: string = 'rgba(27, 27, 27, 0.74), rgba(27, 27, 27, 0.74)'

  protected responsive: boolean = false


  @app.Getter('GetShowSb') protected GetShowSb: any
  @app.Getter('GetWidth') protected GetWidth: any
  @app.Mutation('SetShowSbToggle') protected SetShowSbToggle: any
  @app.Mutation('SetShowSb') protected SetShowSb: any
  @app.Mutation('SetWidth') protected SetWidth: any

  set drawer(val: Boolean) {
    this.SetShowSbToggle(val)
  }

  get drawer() {
    return this.GetShowSb
  }

  protected onResponsiveInverted(): void {
    if (window.innerWidth > 991) {
      this.SetShowSb(true)
      this.SetWidth(window.innerWidth)
    } else {
      if (Math.abs(window.innerWidth - this.GetWidth) > 100) {

        this.SetWidth(window.innerWidth)
        this.SetShowSb(false)
      }

    }
  }

  protected mounted(): void {
    this.SetWidth(window.innerWidth)
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
    this.workspace = localStorage.getItem('workspace') || ''
  }

  protected beforeDestroy(): void {
    window.removeEventListener('resize', this.onResponsiveInverted)
  }

  showSupportQuestions() {
    this.SetTitleDialog(this.$t('support.faqTitle'))
    this.SetFormSDialog('QuestionsForm')
    this.SetFullDialogShow(true)
  }

  sendEventToRoistat(item:any) {
    // let params = [
    //   {
    //     "name": "Посещение категории " + (item.route == 'Standmans' ? "“Стендисты”" :
    //                                       item.route == 'ProductList' ? "“Продукция”" :
    //                                       item.route == 'ShardList' ? "“Собранные данные”" :
    //                                       item.route == 'Survey' ? "“Анкета”" :
    //                                       item.route == 'Statistics' ? "“Статистика”" :
    //                                       item.route == 'Support' ? "“Техподдержка”" : ""),
    //     "data": {
    //       "company": this.userCompany.title
    //     }
    //   }
    // ]
    // this.sendEvent(params)
  }

//   baseColorText = '#363636'
//   changeColor(){
//     if(this.baseColorText === "grey"){
//       this.baseColorText = "red"
//     }else {
//       this.baseColorText = "grey"
//     }
//   }
//   get userStyle() {
//     return {
//       '--base-color-text': this.baseColorText
//     }
//   }
}

